/* import __COLOCATED_TEMPLATE__ from './sh-sidebar.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { IN_REACT_NATIVE } from 'sh-www/constants/environment';
import clsx from 'clsx';

const CLASS_NAME = 'sh-sidebar';
const OPEN_CLASS_NAME = `${CLASS_NAME}__open`;
const OPEN_CLASS_NAME_HIDDEN = `${OPEN_CLASS_NAME}--hidden`;

class SidebarComponent extends Component {
  get baseClassName() {
    return CLASS_NAME;
  }

  get destinationElement() {
    return document.body;
  }

  get openClassNames() {
    return clsx(
      OPEN_CLASS_NAME,
      (IN_REACT_NATIVE || !this.args.targetUrl) && OPEN_CLASS_NAME_HIDDEN,
    );
  }

  @action
  handleKeyDown(e) {
    if (e.key === 'Escape') {
      this.args.onCloseClicked();
    }
  }
}

export default SidebarComponent;
